/*
 *  Copyright (c) Qwoach LLC 2022. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 9/3/2022
 */

export const WorkflowDocumentType = Object.freeze({
	SAFETY_RISK_ASSESSMENT: "SAFETY_RISK",
	DAILY_LIVING: "DAILY_LIVING",
	CLIENT_SAFETY_PLAN: "CLIENT_SAFETY_PLAN",
	BRIEF_INTAKE_FORM: "BRIEF_INTAKE_FORM",
	DETAILED_INTAKE_FORM: "DETAILED_INTAKE_FORM",
	CRISIS_MANAGEMENT_PLAN: "CRISIS_MANAGEMENT_PLAN",
	RECOVERY_GOALS_WORKSHEET: "RECOVERY_GOALS",
})
